<ng-container *transloco="let t">
  <!-- Use flex with column direction and set a fixed height -->
  <div class="flex flex-col h-full">
    <!-- Content section - scrollable -->
    <div class="flex-1 overflow-y-auto">
      <div class="mb-5">
        <p class="dark:text-surface-400">{{ t("app.organization-settings.inviteDialog.description") }}</p>
      </div>
      <p-fluid>
        <form [formGroup]="form">
          <formly-form [form]="form" [model]="model" [fields]="fields" [options]="options"></formly-form>
        </form>
      </p-fluid>
    </div>

    <!-- Footer section -->
    <div class="mt-3 pt-3 border-t border-surface-200 dark:border-surface-700">
      <div class="flex flex-row gap-3 justify-end">
        <p-button
          [label]="t('app.common.cancel')"
          severity="secondary"
          (click)="ref.close()"
          [disabled]="this.loading"
        ></p-button>
        <p-button
          [label]="t('app.common.save')"
          (click)="submitInvitation()"
          [disabled]="form.invalid || this.loading"
          [loading]="this.loading"
        />
      </div>
    </div>
  </div>
</ng-container>
